import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import * as c from '../../../../constant'
import * as actions from '../../../../action';

function UpdateModal({
  applicationId,
  id,
  history,
  updateLandMarketValue,
  formData,
  setFormData,
  getLandMarketValueList,
  updateList,
  getAdjustmentFactorList,
  adjustmentFactorList,
  ordinanceRevisionId,
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => { 
    getAdjustmentFactorList({ ordinance_revision_id: ordinanceRevisionId });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);
  
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
    };
    updateLandMarketValue(applicationId, formData.rptax_land_appraisal_id, id, args, () => {
      setModal({ isOpen: false });
      getLandMarketValueList(applicationId, updateList.rptax_land_appraisal_id);
      history.push(`/rpt/land/applications/${applicationId}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.LAND_MARKET_VALUE_FORM_DATA)));
    }
  };

  const createDropDown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };
  /* eslint-disable eqeqeq */
  const getSelectedOptions = (list, value) => {
    return createDropDown(list).find(x => x.label == value) || {};
  };

  const handleAdjustmentFactorSelect = e => {
    setFormData({
      ...formData,
      rptax_land_adjustment_factor_id: e.value,
      adjustment_factor: e.label,
    });
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">Adjustment Value:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropDown(adjustmentFactorList)}
                styles={customStyle}
                placeholder="Select Adjustment Value"
                value={
                  getSelectedOptions(
                    adjustmentFactorList, 
                    formData.adjustment_factor
                  )
                }
                onChange={e => {
                  handleAdjustmentFactorSelect(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  applicationId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  getLandMarketValueList: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateLandMarketValue: PropTypes.instanceOf(Function).isRequired,
  getAdjustmentFactorList: PropTypes.instanceOf(Function).isRequired,
  adjustmentFactorList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  adjustmentFactorList: _.get(api, `${c.GET_ADJUSTMENT_FACTOR_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
